import { castArray } from 'lodash';
import { lazy } from 'react';
import * as React from 'react';
import { useFeatureFlags } from 'utils/features';
import { t } from 'utils/localize';
import { IAccessControlProps } from './AccessControl';
const NotAllowed = lazy(() => import('containers/error/NotAllowed'));

export interface IValidateFeatureFlagsProps extends Pick<IAccessControlProps, 'featureFlags'> {
  fallback?: React.ReactElement;
}

export const ValidateFeatureFlags: React.FC<IValidateFeatureFlagsProps> = (props) => {
  const { children, featureFlags, fallback = <NotAllowed message={t(`Feature is not available`)} /> } = props;

  const hookArgs = castArray(featureFlags);
  const isFeatureEnabled = useFeatureFlags(...hookArgs);

  return isFeatureEnabled ? <>{children}</> : fallback;
};
